import { render, staticRenderFns } from "./fan-inspection-solution.vue?vue&type=template&id=56bffd87&scoped=true"
import script from "./fan-inspection-solution.vue?vue&type=script&lang=js"
export * from "./fan-inspection-solution.vue?vue&type=script&lang=js"
import style0 from "./fan-inspection-solution.vue?vue&type=style&index=0&id=56bffd87&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bffd87",
  null
  
)

export default component.exports